import styled from '../node_modules/.pnpm/@linaria_react@3.0.0-beta.15_react@17.0.2/node_modules/@linaria/react/esm/styled.js';
import { getPresets } from '@indriver/vandermeer';
import '@indriver/yrel';
import preset from './preset.js';

var style = getPresets(preset, {});
var Box = /*#__PURE__*/styled("div")({
  name: "Box",
  class: "bplllpa",
  vars: {
    "bplllpa-0": [style.fontFamily]
  }
});
var Label = /*#__PURE__*/styled("label")({
  name: "Label",
  class: "lrbgizq",
  vars: {
    "lrbgizq-2": [function (_ref) {
      var disabled = _ref.disabled;
      return disabled ? "" + style.colorDisabled() : "" + style.labelColor();
    }]
  }
});
var LabelText = /*#__PURE__*/styled("span")({
  name: "LabelText",
  class: "l1w6xd7a"
});
var LabelRequired = /*#__PURE__*/styled("span")({
  name: "LabelRequired",
  class: "ll76pbs"
});

var getHintColor = function getHintColor(_ref2) {
  var disabled = _ref2.disabled,
      invalid = _ref2.invalid;

  if (disabled) {
    return "" + style.colorDisabled();
  }

  if (invalid) {
    return "" + style.hintColorInvalid();
  }

  return "" + style.hintColorInfo();
};

var Hint = /*#__PURE__*/styled("div")({
  name: "Hint",
  class: "ha74w8d",
  vars: {
    "ha74w8d-2": [function (_ref3) {
      var hintGap = _ref3.hintGap;
      return hintGap !== undefined ? hintGap + "px" : '4px';
    }],
    "ha74w8d-3": [getHintColor]
  }
});
var HintArea = /*#__PURE__*/styled("div")({
  name: "HintArea",
  class: "h1ebtqw7"
});

export { Box, Hint, HintArea, Label, LabelRequired, LabelText };


require('../../styles-linaria/form-field/form-field.styles.css');
